import React from 'react';
import ParagraphProps from '@src/components/Paragraph/paragraph-props';
import {TikTokEmbed} from "react-social-media-embed";

interface TikTokModel {
  name: string;
  provider: string;
  url: string;
  id: string;
  author?: string;
}

const TiktokParagraph = (props: ParagraphProps) => {
  const model = props.paragraph.data as TikTokModel;
  if (!model.id) {
    return null;
  }

  const src = `https://www.tiktok.com/embed/v2/${model.id}`;
  return (
    <section className="paragraph tiktok-paragraph">
      <TikTokEmbed url={src} width={325}/>
    </section>
  );
};

export default TiktokParagraph;
